module.exports = __webpack_public_path__ + "static/img/16.b1763c2a.png";